import { Outlet } from "react-router-dom"
import SensorParameterCommonComponent from "../common/sensor-parameter.component";

const SensorParameterComponent = () => {
    return <div>
        <SensorParameterCommonComponent />
    </div>
}

export default SensorParameterComponent;